const LOGIN_FORM_NAME = 'Login';
const FORGET_PASSWORD_FORM_NAME = 'ForgetPassword';
const RESET_PASSWORD_FORM_NAME = 'ResetPassword';
const AUTH_TOKEN_KEY = 'ehrms@auth_token';
const AUTH_TOKEN_TIME = 'ehrms@auth_token_time';
const REFRESH_TOKEN_KEY = 'ehrms@refresh_token';

export { LOGIN_FORM_NAME, AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY, FORGET_PASSWORD_FORM_NAME, RESET_PASSWORD_FORM_NAME, AUTH_TOKEN_TIME};
